// removed by extract-text-webpack-plugin
module.exports = {"awards":"_3qZZ7fPrWedDWcGO4P7BsF","awardTabList":"_397iQJiP__mtt2wq_gF50g","sticky":"_6CemCsoRUmgpibYdESgJc","awardList":"G1VljEwtaRYo9To_7mA6e","awardLong":"_2gId82wQgy1JNcHWjUHzWJ","isActive":"_3IeUn9nU-YMTRH9Wh90WeE"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Awards/Awards.css
// module id = 187
// module chunks = 0